import { alpha, darken, getLuminance } from "@mui/material";
import color from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

/**
 * Workspace primary and accent, plus the variants the home dashboard needs.
 *
 * The accent is used for fills and decoration as it is; text and thin icons on
 * white use `accentText`, a darker step, because some workspaces have a light
 * accent (yellow) that is unreadable on white.
 */
export const useDashboardColors = () => {
  const { colors } = useWorkspaceColors();
  const accent = colors.accent;
  const isLightAccent = getLuminance(accent) > 0.5;

  return {
    primary: colors.primary_dark,
    accent,
    accentText: darken(accent, isLightAccent ? 0.5 : 0.25),
    // Icons are larger than text, so a normal accent only needs darkening
    // when it is light.
    accentIcon: isLightAccent ? darken(accent, 0.45) : accent,
    accentSoft: alpha(accent, 0.12),
    accentBorder: alpha(accent, 0.35),
    // Text drawn on an accent fill.
    onAccent: isLightAccent ? color.gray900 : color.white,
  };
};

export type DashboardColors = ReturnType<typeof useDashboardColors>;
